import { InputAdornment, TextField } from "@mui/material";

const PercentNumberField = ({ onChange, value, sx, ...props }) => {
    return (
        <TextField
            type="number"
            variant="outlined"
            value={value}
            onChange={onChange}
            placeholder="0.00"
            sx={{ width: '10.75rem', ...sx }}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start"><b>%</b></InputAdornment>
                    ),
                },
                htmlInput: {
                    step: "0.01",
                    min: 0
                }
            }}
            {...props}
        />
    );
}

export default PercentNumberField;